import { commentItems } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-500">真实读者的使用体验，听听他们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name} 头像`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: item.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-secondary-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}